import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
import {Img} from 'ui';

export const Image = styled(Img)({
  width: 334,
  height: 191,
  // backgroundSize: 'cover',
});

export const Conseil = styled('a')({
  display: 'flex',
  flexDirection: 'column',
  width: 334,
  textDecoration: 'none',
  marginBottom: 20,
});

export const ConseilItemTitle = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.white,
  padding: '19px 22px',
});

export const Title = styled('div')({
  fontSize: 16,
  lineHeight: '19px',
  fontWeight: 'bold',
  color: colors.black,
  fontFamily: fonts.title,
  textAlign: 'left',
});

export const Description = styled('div')({
  '& p': {
    marginBottom: 0,
    color: colors.grey,
    fontSize: 13,
    lineHeight: '16px',
  },
});
